
$(document).ready(function(){

  if($('.diwali_popup').length > 0){

    var delaysec = parseInt($('.diwali_popup').attr('data-delay-seconds')) * 1000;
    //get cookie
    function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }
    
    if(!getCookie('diwali-popup')){
      setTimeout(function(){
        $('.diwali_popup').addClass('modal--is-active');
        $('html').addClass('modal-open');
      }, delaysec); 
    }      
    
    $(document).on('click','.diwali_popup .modal__close', function(){
      $('.diwali_popup').removeClass('modal--is-active');
      $('html').removeClass('modal-open');
      function setCookie(name, value, days) {
          var d = new Date;
          d.setTime(d.getTime() + days * 60 * 60 * 1000);
          document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      }
      var delday = parseInt($('.diwali_popup').attr('data-delay-days'));
      setCookie('diwali-popup',true,delday);
    });
  }  

  $('.social_reviews_slider').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });
  $('.announcement-slider').slick({
    dots: false,
    arrows: false,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:`<button type='button' class='slick-prev pull-left'><svg fill="none" focusable="false" width="12" height="10" class="svg-icon icon--nav-arrow-left-small  icon--direction-aware " viewBox="0 0 12 10"><path d="M12 5L2.25 5M2.25 5L6.15 9.16M2.25 5L6.15 0.840001" stroke="currentColor" stroke-width="2"></path></svg></button>`,
    nextArrow:`<button type='button' class='slick-next pull-right'><svg fill="none" focusable="false" width="12" height="10" class="svg-icon icon--nav-arrow-right-small  icon--direction-aware " viewBox="0 0 12 10"><path d="M-3.63679e-07 5L9.75 5M9.75 5L5.85 9.16M9.75 5L5.85 0.840001" stroke="currentColor" stroke-width="2"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          arrows: false
        }
      }
    ]
  });

    if ($(window).width() <= 768) {
  $('.custom-announcement-content-slide').slick({
    dots: false,
    arrows: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: `<button type='button' class='slick-prev pull-left'><svg fill="none" focusable="false" width="12" height="10" class="svg-icon icon--nav-arrow-left-small  icon--direction-aware " viewBox="0 0 12 10"><path d="M12 5L2.25 5M2.25 5L6.15 9.16M2.25 5L6.15 0.840001" stroke="currentColor" stroke-width="2"></path></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right'><svg fill="none" focusable="false" width="12" height="10" class="svg-icon icon--nav-arrow-right-small  icon--direction-aware " viewBox="0 0 12 10"><path d="M-3.63679e-07 5L9.75 5M9.75 5L5.85 9.16M9.75 5L5.85 0.840001" stroke="currentColor" stroke-width="2"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 2,
        }
      }
    ]
  });
}

   
  $('.review-slider-item').map(function(){
    $(this).find('#review-read').click(function(){
      $(this).toggleClass("active")
      $(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
      $(this).parent().parent('.review-slider-item-inner').toggleClass('cls-added');
    })
  });

  // ========================================
  //   CONTACT PAGE JS
  // =======================================
  
  $('.contact-b-item-1').click(function(){
    $('.contact-block-ul').hide();
    $('.content-need-help-form').show();
  })
  $('.contact-b-item-2').click(function(){
    $('.contact-block-ul').hide();
    $('.content-need-help-form-2').show();
  })
  $('.contact-b-item-3').click(function(){
    $('.contact-block-ul').hide();
    $('.content-need-help-form-3').show();
  })
  
  $('.content-back-btn').click(function(){
    $('.contact-block-ul').show();
    $('.content-need-help-form').hide();
    $('.content-need-help-form-2').hide();
    $('.content-need-help-form-3').hide();
  })

  $('.contact_file_upload').find('input[type="file"]').change(function(){
    $(this).addClass('hide_label');
  })

  $('.contact_file_upload').find('input[type="file"]').change(function(){
    var tt = $(this).prop("files")[0];
    $(this).closest('.content-form-input-succes').find('.upload_succefully').show();
  })
  
  
  // ================================================
  //   TAB COLLECTION SECTION
  // =================================================
  
  $('document').ready(function(){
    $('.coll-tab-list').find('.coll-title-list').map(function(){
      $(this).click(function(){
        var position = $(this).position();
        var width = $(this).width();
        $(".barr").css({"left":+ position.left,"width":width});
        $(this).addClass('coll-title-list-active').siblings().removeClass('coll-title-list-active');
        var collId = $(this).attr('data-coll');
        $('.coll-pro-list').map(function(){
          var proId = $(this).attr('data-pro');
          if(collId == proId) {
            $(this).addClass('pro-list-show');
          }else{
            $(this).removeClass('pro-list-show');
          }
        })
      })
    })  
    var actWidth = $(".coll-tab-list").find(".coll-title-list-active").width();
    var actPosition = $(".coll-title-list-active").position();
    if( $(".coll-title-list-active").length > 0 ){
     $(".barr").css({"left":+ actPosition.left,"width": actWidth}); 
    }    
  })
  
  
  
  $(".variant_box").change(function(){
    var id = $(this).val()
    $("input[name='id']").val(id)
  });
  
  
  
  // =========== PRODUCT PRICE CHANGE ON SELECTED VARIANT =============
  
  $('.variant_box').on("change",function(){
    var compr = $(this).find('option:selected').attr('data-compr');
    var pr = $(this).find('option:selected').attr('data-pr');
    var inrhtml = "";
    var saved_price = "";
    if(compr > pr) {
      inrhtml = '<span class="grid-product__price--original">'+ theme.Currency.formatMoney(compr, theme.settings.moneyFormat) +'</span><span class="sale-price">'+ theme.Currency.formatMoney(pr, theme.settings.moneyFormat) +'</span>'
      
      if(theme.settings.product_save_amount){
        
        if(theme.settings.product_save_type == 'dollar'){
          saved_amount = theme.Currency.formatMoney((compr - pr), theme.settings.moneyFormat);
        }else{
          saved_amount = Math.round(((compr - pr) * 100) / compr);
          saved_price += '<span class="pro_card_off_price grid-product__tag--sale">Save '+saved_amount+'%</span>';
        }
          $(this).closest('.grid__item_product').find('.grid-product__tag').html(saved_price);      
      }
      $(this).closest('.grid__item_product').find('.grid-product__tag').removeAttr('hidden','hidden')
    }else{
      inrhtml = '<span class="">'+ theme.Currency.formatMoney(pr, theme.settings.moneyFormat) +'</span>';
      $(this).closest('.grid__item_product').find('.grid-product__tag').attr('hidden','hidden')
    }    
    $(this).closest('.grid-product__content').find('.grid-product__price').html(inrhtml);
  });

 setTimeout(myFunc, 4000);
  function myFunc(){
    $('.variant_box').on("change",function(){
      var compr = $(this).find('option:selected').attr('data-compr');
      var pr = $(this).find('option:selected').attr('data-pr');
      var inrhtml = "";
      
      if(compr > pr) {
        inrhtml = '<span class="grid-product__price--original">'+ theme.Currency.formatMoney(compr, theme.settings.moneyFormat) +'</span><span class="sale-price">'+ theme.Currency.formatMoney(pr, theme.settings.moneyFormat) +'</span>'
        
        if(theme.settings.product_save_amount){
          var saved_price = "";
          if(theme.settings.product_save_type == 'dollar'){
            var saved_amount = theme.Currency.formatMoney((compr - pr), theme.settings.moneyFormat);
          }else{
            var saved_amount = Math.round(((compr - pr) * 100) / compr);
            saved_price += '<span class="pro_card_off_price grid-product__tag--sale">Save '+saved_amount+'%</span>';
          }
          $(this).closest('.grid__item_product').find('.grid-product__tag').html(saved_price);
        }
        $(this).closest('.grid__item_product').find('.grid-product__tag').removeAttr('hidden','hidden')
      }else{
        inrhtml = '<span class="">'+ theme.Currency.formatMoney(pr, theme.settings.moneyFormat) +'</span>';
        $(this).closest('.grid__item_product').find('.grid-product__tag').attr('hidden','hidden')
      }  
      $(this).closest('.grid-product__content').find('.grid-product__price').html(inrhtml);
    });

    // FOR ATC SELECTED VARIANT
    $(".variant_box").change(function(){
      var id = $(this).val()
      $("input[name='id']").val(id)
    });
  }

  $('.grid__item_product form').on('submit', function(e){
    e.preventDefault();
    var form = $(this).closest('form');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        console.log('hihih')
      },
      success: function(data){
        console.log('success')
      }
    });  
  });  

  
});


// ======================== Brand Section =====================

$('.barnd_item').map(function(){
  $(this).find('.brand_item_img').mouseenter(function(){
    $(this).addClass('active').parent().siblings().children().removeClass('active');
    var dd = $(this).attr('data-img')
    $('.brand_logo_content').find('.blc-inr').map(function(){
      var tt = $(this).attr('data-text')
      if(dd == tt) {
        $(this).addClass('show')
      }else{
        $(this).removeClass('show')
      }
    })
  })
})

// $('.brand_slider').slick({
//   dots: false,
//   infinite: false,
//   arrows: false,
//   speed: 1000,
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   touchThreshold:100,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 749,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: false,
//         centerMode: true,
//         centerPadding:'80px',
//       }
//     }
//   ]
// });


// if(theme.settings.product_save_amount){
//               if(theme.settings.product_save_type == 'dollar'){
//                 var saved_amount = theme.Currency.formatMoney((variant.compare_at_price - variant.price), theme.settings.moneyFormat);
//                 pricehtml += '<span class="product-tag--sale">Save '+saved_amount+'</span></div>';  
//               }else{
//                 var saved_amount = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
//                 pricehtml += '<span class="product-tag--sale">Save '+saved_amount+'%</span></div>'; 
//               }             
//             } 
